// export * from './academic/attendance.service';

// lms
export * from './academic/lms.service';
export * from './academic/subject.service';
export * from './academic/sections-subjects.service';
export * from './academic/curriculum.service';
export * from './academic/curriculum-item.service';
export * from './academic/assessment.service';
export * from './academic/discussions.service';
export * from './academic/plans.service';
export * from './academic/question.service';
export * from './academic/assignment.service';
export * from './academic/objective.service';
export * from './academic/syllabus-level.service';
// lms
export * from './plans/plan.service';

// Timetable
export * from './academic/teacher-allotment.service';
export * from './academic/viewschedule.service';
export * from './study-table/study-table.service';
export * from './study-table/study-table-ui.service';
export * from './classes/student.service';

// common
export * from './common/language.service';
export * from './common/date-time-validator.service';
export * from './common/date-time.service';
export * from './common/files.service';
// EXTERNAL SERVICES
export * from './externalservices/urlmeta.services';

// System Settings
export * from './system-settings/academic-year-manage.service';

// Communications
export * from './communications/event.service';
export * from './communications/alert-types.service';
export * from './communications/user-types.service';
export * from './communications/class-section-department.service';
export * from './communications/email.service';
export * from './communications/gallary.service';
export * from './communications/social-learning.service';
export * from './communications/circulars.service';
// LookUp
export * from './lookup/lookup.service';

// User service
export * from './users/user.service';
export * from './users/attachments-managements.service';
// classes service
export * from './classes/classes-service';

// Attendance
export * from './attendance/attendance-service';

// school
export * from './school/school.service';

// subjects settings
export * from './academic/subjects-settings.service';
// Start Evaluations
export * from './evaluations/evaluations.service';
// End Evaluations
// Start Account
export * from './account/account.service';
// End Account
// Start Dashboard
export * from './dashboard/main-dashboard.service';
// End Dashboard
// Start Students Portal
export * from './students/menu.service';
